<template>
    <div class="billing-history-container">
        <p class="title">Billing History</p>
        <ArtistBillingHistoryTable
            v-if="role === 'artist'"
            :role="role"
            :user="parseInt(user)"
        />
        <VenueBillingHistoryTable
            v-if="role === 'venue'"
            :role="role"
            :user="parseInt(user)"
        />
    </div>
</template>
<script>
    import ArtistBillingHistoryTable from '@/components/ui/tables/ArtistBillingHistoryTable'
    import VenueBillingHistoryTable from '@/components/ui/tables/VenueBillingHistoryTable'
    export default {
        name: 'BillingHistory',
        components: {
            ArtistBillingHistoryTable,
            VenueBillingHistoryTable
        },
        props: {
            role: {
                required: true,
                type: String
            },
            user: {
                required: true,
                type: String
            }
        }
    }
</script>
<style lang="scss" scoped>
    $mobileMax: 600px;
    @media screen and (max-width: $mobileMax) {
        .billing-history-container {
            padding: 100px 16px !important;
            .title {
                font-size: 26px !important;
            }
        }
    }
    p {
        margin-bottom: 0px;
    }
    button {
        border: none;
    }
    .billing-history-container::-webkit-scrollbar {
        width: 8px;
    }
    .billing-history-container::-webkit-scrollbar-track {
        background-color: none;
    }
    .billing-history-container::-webkit-scrollbar-thumb {
        max-height: 64px;
        border-radius: 8px;
        background: #8b8b8b;
    }
    .billing-history-container {
        width: 100%;
        max-width: 1176px;
        overflow-x: scroll;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        gap: 16px;
        padding: 100px 60px;

        .title {
            color: #dedede;
            font-family: 'Instrument Sans';
            font-size: 44px;
            font-style: normal;
            font-weight: 500;
            line-height: 110%;
            letter-spacing: -1.76px;
        }
    }
</style>
